/* eslint-disable @tanstack/query/exhaustive-deps -- queryFn closes over Clerk getToken; cache keyed by userId+sessionId */
import { useAuth } from '@clerk/react';
import { useQuery } from '@tanstack/react-query';
import { fetchAssignedLeads } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function useAccountLeads() {
  const { userId, sessionId } = useAuth();
  const getToken = useAccountGetToken();
  return useQuery({
    queryKey: ['account', 'leads', userId, sessionId],
    queryFn: () => fetchAssignedLeads(getToken),
    enabled: Boolean(userId),
    staleTime: 30_000,
    refetchOnWindowFocus: false
  });
}
